import { FC, memo } from 'react'

import { ContentProps } from './ContentProps'

import * as SC from './styles'

export const Content: FC<ContentProps> = memo(({ children, face, isPending, noPadding }) => (
  <SC.Box id="orbit-page" $face={face} $noPadding={noPadding}>
    <SC.Inner>{children}</SC.Inner>
    {isPending && (
      <SC.SpinnerBackground>
        <SC.WrappedSpinner centered />
      </SC.SpinnerBackground>
    )}
  </SC.Box>
))
